import React from "react";
import styles from "./style.module.scss";
import { useSelector } from "react-redux";
import { RootState } from "../../../state";
import { isEqual } from "lodash";
import SessionClock from "../SessionClock";

export default function SessionStatus() {
  const status = useSelector(
    (state: RootState) => state.aks.v2.timing?.session?.status,
    isEqual,
  );

  const {
    currentFlag = null,
    // currentFlagTime = null,
    currentLap = null,
    finalLaps = null,
    finalAddedLaps = null,
    finalTime = null,
    finalType = null,
    isFinished = null,
    isSessionRunning = null,
    sessionStartTime = null,
    stopTime = null,
    stoppedMilliSeconds = null,
  } = typeof status === "object" ? status : {};

  const flagIndicator = (
    <div
      className={`${styles.flagContainer} ${
        isFinished ? styles.CHECKERED : styles[currentFlag ? currentFlag : ""]
      }`}
    >
      {currentFlag === "FULL_YELLOW" && !isFinished ? "FCY" : null}
      {currentFlag === "SAFETY_CAR" && !isFinished ? "SC" : null}
      {currentFlag === "YELLOW" && !isFinished ? "" : null}
    </div>
  );

  const lapsIndicator = (
    <>
      Lap {currentLap} / {finalLaps}{" "}
      {finalAddedLaps
        ? `(${(finalLaps || 0) - finalAddedLaps} + ${finalAddedLaps})`
        : ""}
    </>
  );

  const timeIndicator = (
    <SessionClock
      finalTime={finalTime}
      sessionStartTime={sessionStartTime}
      stopTime={stopTime}
      isSessionRunning={isSessionRunning}
      stoppedMilliSeconds={stoppedMilliSeconds}
    ></SessionClock>
  );

  return (
    <div className={styles.statusRow}>
      {flagIndicator}
      <div className={styles.container}>
        {finalType?.includes("BY_LAPS") ? lapsIndicator : <></>}
        {finalType?.includes("BY_TIME") ? timeIndicator : <></>}
      </div>
    </div>
  );
}
